const themeConfig = {
    primary: "#0674fd",
    secondary: "#01d0fa"
};

export default themeConfig;